import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { AppPaths } from '../app-paths';
import {Observable} from 'rxjs/index';

@Injectable()
export class AuthGuard implements CanActivate {

  public isAuthentificated: boolean;

  constructor(
    public authService: AuthenticationService,
    public router: Router,
  ) {
    this.isAuthentificated = false;
    this.authService.isAuthenticated.subscribe((value: boolean) => {
      this.isAuthentificated = value;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (!this.isAuthentificated) {
        this.router.navigate([AppPaths.signin_url]);
        return false;
      }
      return true;
  }
}
